import config from "config";
import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";

const api=new APICore();

function fetchUploadInstrumentBatchesApi(params:FilterMetadata){
    const baseUrl=`${config.BACKEND_TXN_BASE_URL}/instruments-batch-upload`;
    return api.get(`${baseUrl}`,params)
}

function fetchUploadInstrumentBatchByIdApi(params:any){
    const baseUrl=`${config.BACKEND_TXN_BASE_URL}/instruments-batch-upload/${params?.id}`;
    return api.get(`${baseUrl}`,{})
}

function fetchInstrumentsByBatchIdApi(params:any){
    const baseUrl=`${config.BACKEND_TXN_BASE_URL}/instruments-upload`;
    return api.get(`${baseUrl}`,params)
}

export{
    fetchUploadInstrumentBatchesApi,
    fetchUploadInstrumentBatchByIdApi,
    fetchInstrumentsByBatchIdApi
}